import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import dashboardReducer from './slices/dashboardSlice';
import productionReducer from './slices/productionSlice';
import qualityReducer from './slices/qualitySlice';
import maintenanceReducer from './slices/maintenanceSlice';
import operatorReducer from './slices/operatorSlice';
import masterDataReducer from './slices/masterDataSlice';
import supplyChainReducer from './slices/supplyChainSlice';
import scrapReducer from './slices/scrapSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    production: productionReducer,
    quality: qualityReducer,
    maintenance: maintenanceReducer,
    operator: operatorReducer,
    masterData: masterDataReducer,
    supplyChain: supplyChainReducer,
    scrap: scrapReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;